import { render, staticRenderFns } from "./SurveyScaffold.vue?vue&type=template&id=3de3e33a&scoped=true&"
import script from "./SurveyScaffold.vue?vue&type=script&lang=js&"
export * from "./SurveyScaffold.vue?vue&type=script&lang=js&"
import style0 from "./SurveyScaffold.vue?vue&type=style&index=0&id=3de3e33a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de3e33a",
  null
  
)

export default component.exports